import { FormProvider, useForm } from 'react-hook-form';
import { PaymentData } from '../../services/api.types';
import dayjs, { Dayjs } from 'dayjs';
import { Datepicker } from '../Datepicker';
import { useState } from 'react';

import { apiService } from '../../services/api';
import { DraggableModal } from '../DraggableModal';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Button } from '../Button';
import { UseControllerProps } from 'react-hook-form';
import { useToast } from '../../hooks';

type ModalFormRules = { [key: string]: UseControllerProps['rules'] };

export interface UpdatePaymentModalProps {
  open: boolean;
  onClose: () => void;
  paymentData: PaymentData;
  onUpdatedPayment: (paymentData: PaymentData) => void;
}

interface UpdatePaymentFormValues {
  dueDate: dayjs.Dayjs;
}

export const formRules: ModalFormRules = {
  dueDateRequired: {
    required: 'Data de vencimento é obrigatória',
    validate: (value: Dayjs) => {
      return isNaN(value.toDate().getTime()) ? 'Data inválida' : true;
    },
  },
};

export const UpdatePaymentModal = ({
  open,
  onClose,
  paymentData,
  onUpdatedPayment,
}: UpdatePaymentModalProps) => {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const formDefaultValues: UpdatePaymentFormValues = {
    dueDate: dayjs(paymentData.dueDate),
  };

  const updatePaymentForm = useForm<UpdatePaymentFormValues>({
    mode: 'all',
    defaultValues: formDefaultValues,
  });

  const onSubmit = async (data: UpdatePaymentFormValues) => {
    const dueDate = data.dueDate.startOf('day').toDate();
    setIsLoading(true);
    await apiService
      .updatePayment(paymentData.id, { dueDate })
      .then((updatedPayment) => {
        toast.success('Pagamento atualizado com sucesso');
        onUpdatedPayment(updatedPayment);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <DraggableModal open={open} onClose={onClose} title="Atualizar pagamento">
      <FormProvider {...updatePaymentForm}>
        <form
          onSubmit={updatePaymentForm.handleSubmit(onSubmit)}
          className="flex flex-col items-center justify-between gap-6"
        >
          <div className="pt-5">
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <Datepicker
                labelOut={false}
                name="dueDate"
                label="Data de vencimento"
                disablePast
                rules={formRules.dueDateRequired}
              />
            </LocalizationProvider>
          </div>
          <Button
            isLoading={isLoading}
            type="submit"
            fullWidth={false}
            circular
          >
            Atualizar
          </Button>
        </form>
      </FormProvider>
    </DraggableModal>
  );
};
